/**
 * Utilitário para obter o ID da empresa autenticada
 * APENAS o ID é armazenado - todos os outros dados devem ser buscados do backend
 */

export const obterIdEmpresa = (): string | null => {
  // Sessão de prefeitura nunca resolve para uma empresa: o `userId` gravado no
  // login da prefeitura é o id DELA. Lê-lo aqui carregaria (e editaria) a empresa
  // de mesmo id, ou devolveria 404 quando esse id não existe entre as empresas.
  const userType =
    localStorage.getItem('userType') || sessionStorage.getItem('userType');

  if (userType === 'prefeitura') {
    return null;
  }

  // Prioridade: empresaId (gravado no login da empresa) > userId (gravado apenas
  // pelo autocadastro, que não grava empresaId)
  let empresaId = localStorage.getItem('empresaId') || sessionStorage.getItem('empresaId');

  if (!empresaId) {
    empresaId = localStorage.getItem('userId') || sessionStorage.getItem('userId');
  }

  return empresaId;
};
